const PRIORITY_STYLES: Record<number, { label: string; bar: string; text: string }> = {
  1: { label: 'P1', bar: 'bg-red-600', text: 'text-red-700' },
  2: { label: 'P2', bar: 'bg-orange-500', text: 'text-orange-700' },
  3: { label: 'P3', bar: 'bg-amber-500', text: 'text-amber-700' },
  4: { label: 'P4', bar: 'bg-blue-500', text: 'text-blue-700' },
  5: { label: 'P5', bar: 'bg-gray-400', text: 'text-gray-600' },
};

interface PriorityIndicatorProps {
  priority: number | null;
}

export function PriorityIndicator({ priority }: PriorityIndicatorProps) {
  if (!priority || !PRIORITY_STYLES[priority]) {
    return <span className="text-xs text-gray-400">—</span>;
  }

  const { label, bar, text } = PRIORITY_STYLES[priority];

  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${text}`}>
      <span className={`inline-block h-2 w-2 rounded-sm ${bar}`} aria-hidden="true" />
      {label}
    </span>
  );
}
